/**
 * Simple handler to check whatever given value is function
 * @param {Any} arg Value to check
 * @returns {Boolean} Result of check
 */
export default function isFunc(arg) {
  return typeof arg === 'function';
}
